import { ColumnVisibilityItem } from "providers/Auth";

export const UNITS_TABLE_COLUMNS_TAB_KEY = "units_table";
export const UNITS_CARD_FIELDS_TAB_KEY = "units_card_fields";

export const DEFAULT_UNITS_TABLE_COLUMNS: ColumnVisibilityItem[] = [
  { id: "title", label: "Unit", checked: true, disabled: false },
  {
    id: "property_group",
    label: "Property group",
    checked: true,
    disabled: false
  },
  {
    id: "monthly_rent_amount",
    label: "Total rent",
    checked: true,
    disabled: false
  },
  {
    id: "home_rent_amount",
    label: "Home rent",
    checked: true,
    disabled: false
  },
  {
    id: "site_rent_amount",
    label: "Site rent",
    checked: true,
    disabled: false
  },
  { id: "owner", label: "Owner", checked: true, disabled: false },
  { id: "pms_id", label: "Source", checked: true, disabled: false },
  { id: "leads", label: "Leads", checked: true, disabled: false },
  { id: "lockbox", label: "Lockbox", checked: true, disabled: false },
  { id: "occupied", label: "Current status", checked: true, disabled: false },
  {
    id: "magic_link",
    label: "Allow applications",
    checked: true,
    disabled: false
  },
  { id: "listed", label: "List unit", checked: true, disabled: false }
];

export const UnitCardField = {
  UnitName: "unit_name",
  PropertyAddress: "property_address",
  PropertyName: "property_name",
  Rent: "rent",
  CurrentStatus: "current_status",
  Leads: "leads",
  Lockbox: "lockbox",
  Beds: "beds",
  Baths: "baths",
  SquareFootage: "square_footage",
  Waitlist: "waitlist",
  Activity: "activity",
  AllowApplications: "allow_applications",
  ListUnit: "list_unit"
} as const;

export const DEFAULT_UNITS_CARD_FIELDS: ColumnVisibilityItem[] = [
  {
    id: UnitCardField.UnitName,
    label: "Unit name",
    checked: true,
    disabled: false
  },
  {
    id: UnitCardField.PropertyAddress,
    label: "Property address",
    checked: true,
    disabled: false
  },
  {
    id: UnitCardField.PropertyName,
    label: "Property name",
    checked: false,
    disabled: false
  },
  { id: UnitCardField.Rent, label: "Rent", checked: true, disabled: false },
  {
    id: UnitCardField.CurrentStatus,
    label: "Current status",
    checked: true,
    disabled: false
  },
  { id: UnitCardField.Leads, label: "Leads", checked: true, disabled: false },
  {
    id: UnitCardField.Lockbox,
    label: "Lockbox",
    checked: true,
    disabled: false
  },
  { id: UnitCardField.Beds, label: "Beds", checked: true, disabled: false },
  { id: UnitCardField.Baths, label: "Baths", checked: true, disabled: false },
  {
    id: UnitCardField.SquareFootage,
    label: "Square footage",
    checked: false,
    disabled: false
  },
  {
    id: UnitCardField.Waitlist,
    label: "Waitlist",
    checked: false,
    disabled: false
  },
  {
    id: UnitCardField.Activity,
    label: "Activity",
    checked: true,
    disabled: false
  },
  {
    id: UnitCardField.AllowApplications,
    label: "Allow applications",
    checked: true,
    disabled: false
  },
  {
    id: UnitCardField.ListUnit,
    label: "List unit",
    checked: true,
    disabled: false
  }
];
